module.exports = __webpack_public_path__ + "img/bg-header-stt-should-del.344a9dbe.svg";